

import {create} from '@baidu/infoflow-fe-logger';

import {ENVIRONMENT_LEVEL} from '@/Constant';


function isOnline() {
    return [ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.online].includes(
        process.env.REACT_APP_ENVIRONMENT || ''
    );
}


const getAppName = () => {
    return isOnline() ? 'neisou' : 'neisou-dev';
};

/**
 * 埋点sdk初始化
 */
export const logger = create({
    // commonParams: {
    //     appName: getAppName(),
    // },
    logger: {
        // 内搜ssr场景下，延迟初始化时机（避免找不到window和document变量）
        manualInitialize: true,
    },
});

export function setLoggerUser(encryptedName:string) {
    logger.setCommonParam('uuapId', encryptedName);
    logger.setCommonParam('appName', getAppName());
}


